// import { en } from "@rsonav/shared-config";
import { ru } from "@rsonav/shared-config";
import LocalizedStrings from "react-localization";

const locale = new LocalizedStrings({ ru }); //, en

export default locale;
